/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom'
import { collection, onSnapshot, orderBy, query, where } from 'firebase/firestore'
import { db } from '../../firebase';
import { Box, Chip, Typography, useTheme, useMediaQuery } from "@mui/material"
import { DataGrid, gridNumberComparator } from "@mui/x-data-grid"
import { tokens } from "../../theme"
import { ProcessedButton } from "./lib/ProcessedButton";

const CarcassList = () => {
  const theme = useTheme()
  const navigate = useNavigate()
  const colors = tokens(theme.palette.mode)
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const [items, setItems] = useState<Array<object>>([])
  const individualsRef = collection(db, 'individuals')

  const columns = isMobile ? [
    {
      field: "No",
      headerName: "No",
      width: 50,
      sortComparator: gridNumberComparator,
    },
    {
      field: "individualNo",
      headerName: "個体番号",
      width: 120,
      cellClassName: "name-column--cell",
    },
    {
      field: "demolitionDate",
      headerName: "解体日",
      width: 100,
    },
    {
      field: "processing",
      headerName: "処理",
      width: 80,
      renderCell: (params: any) => (
        <ProcessedButton individualId={params.row.id} />
      ),
    }
  ] : [
    {
      field: "No",
      headerName: "Mo",
      width: 10,
      sortComparator: gridNumberComparator,
    },
    {
      field: "individualNo",
      headerName: "個体識別番号",
      width: 200,
      cellClassName: "name-column--cell",
    },
    {
      field: "demolitionDate",
      headerName: "解体日",
      flex: 1,
    },
    {
      field: "sex",
      headerName: "性別",
      flex: 1,
    },
    {
      field: "age",
      headerName: "推定年齢",
      flex: 1,
    },
    {
      field: "weight",
      headerName: "体重",
      flex: 1,
      valueFormatter: (params: any) => {
        return params.value ? `${params.value} kg` : '';
      },
    },
    {
      field: "processing",
      headerName: "処理",
      flex: 1,
      renderCell: (params: any) => (
        <ProcessedButton individualId={params.row.id} />
      ),
    },
    {
      field: "detail",
      headerName: "詳細",
      flex: 1,
      renderCell: (params: any) => (
        <Chip label="詳細" color="default" size="small" onClick={() => navigate(`/admin/individuals/${params.row.id}`)}></Chip>
      ),
    }
  ]

  useEffect(() => {
    if (!individualsRef) return
    const q = query(individualsRef, where("status", "==", "dismantled"), orderBy("demolitionDate", "desc"))
    const unsubscribe = onSnapshot(q, ({ docs }) => {
      setItems(docs.map((_, i) => {
        return ({ No: i + 1, ..._.data(), id: _.id })
      }))
    })
    return unsubscribe
  }, [])

  return (
    <Box m={isMobile ? "10px" : "20px"}>
      <Typography variant={isMobile ? "h4" : "h3"}>枝肉一覧（熟成庫）</Typography>
      <Box
        mt={isMobile ? 1 : 2}
        height={isMobile ? "70vh" : "80vh"}
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGrid rows={items} columns={columns} />
      </Box>
    </Box>
  )
}
export default CarcassList
